import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { IonicModule } from '@ionic/angular';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { FirmwareMetadataEditorComponent } from './firmware-metadata-editor.component';

@NgModule({
  declarations: [
    FirmwareMetadataEditorComponent,
  ],
  imports: [
    BlockTitleComponent,
    CommonModule,
    FormsModule,
    IonicModule,
    MatButtonModule,
    MatChipsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTableModule,
    ReactiveFormsModule,
  ],
  exports: [
    FirmwareMetadataEditorComponent,
  ],
})
export class FirmwareMetadataEditorModule {}
